import {
  FEATURE_ANDC_COLLAB,
  FEATURE_BLACK_FRIDAY,
  FEATURE_FASHIONWEEK_COLLAB_BUY,
  FEATURE_HM_COLLAB_BUY,
  FEATURE_KLARNA_COLLAB_BUY,
  FEATURE_SNAPCHAT_COLLAB_BUY
} from '../../client/featureToggle'

export const HM = 'hm'
export const KLARNA = 'klarna'
export const SNAPCHAT = 'snapchat'
export const FASHIONWEEK = 'fashionweek'
export const FRIDAY = 'friday'
export const ANDC = 'andc'

export const getCollabFeatureToggle = (collab) =>
  ({
    [HM]: FEATURE_HM_COLLAB_BUY,
    [KLARNA]: FEATURE_KLARNA_COLLAB_BUY,
    [SNAPCHAT]: FEATURE_SNAPCHAT_COLLAB_BUY,
    [FASHIONWEEK]: FEATURE_FASHIONWEEK_COLLAB_BUY,
    [FRIDAY]: FEATURE_BLACK_FRIDAY,
    [ANDC]: FEATURE_ANDC_COLLAB
  }[collab])
